import styled, { css, keyframes } from "styled-components";

const blurAnim = keyframes`
  0%{
    transition-timing-function: cubic-bezier(0,0,.2,.93);
   filter:blur(0px)
  }
  
  100%{
     
    filter:blur(15px)
    }
`;
const scaleAnim = keyframes`
  0%{
    transition-timing-function: cubic-bezier(0.35, 0, 0.2, 1);
    transform: scale(1)
    }
  100%{
     transform: scale(.9);
  }
`;
const unBlurAnim = keyframes`
  0%{
    transition-timing-function: cubic-bezier(0,0,.2,.93);
    filter:blur(15px)
  }
  
  100%{
     
    filter:blur(0px)
    }
`;
const unscaleAnim = keyframes`
  0%{
    transition-timing-function: cubic-bezier(0.35, 0, 0.2, 1);
    transform: scale(.9);
  }
  100%{
    transform: scale(1);
  }
`;
const fadeInAnim = keyframes`
  0%{
    transition-timing-function: cubic-bezier(0.42, 0, 0.07, 0.92);
     opacity:0;
     transform: scale(.6);
  }
  100%{
     transform: scale(1);
     opacity:1;
   } 
`;
const fadeIn = css`
  ${fadeInAnim} 467ms 1 forwards 200ms
`;
const blur = css`
  ${blurAnim} 167ms 1 forwards, ${scaleAnim} 250ms 1 forwards
`;
const unBlur = css`
  ${unBlurAnim} 167ms 1 forwards, ${unscaleAnim} 367ms 1 forwards
`;
/* ${(p) => !!p.blur && "filter: blur(15px); opacity : 0.3"}; */
/* opacity: ${(p) => (p.showLoading ? 0 : 1)}; */
export const BlurBox = styled.div`
  animation: ${(p) => (p.fadeInKeno ? fadeIn : null)};
  animation: ${(p) => (p.blur ? blur : null)};
  animation: ${(p) => (p.unBlur ? unBlur : null)};

  height: 100%;
`;
